export const ROOT_ERROR = "ROOT_ERROR";
export const ROOT_NOTIFICATION = "ROOT_NOTIFICATION";
export const ROOT_LOADING = "ROOT_LOADING";

// For reset root state
export const RESET_ROOT_STATE = "RESET_ROOT_STATE";
